export default __webpack_public_path__ + "static/media/vpMechanical.0b6d5c73.svg";